import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connectModal } from "redux-modal";
import {
  Button,
  ControlGroup,
  Modal,
  ModalContent,
  ModalFooter,
} from "@conserveit/blocks";
import GroupForm from "./GroupForm";

export const ADD_GROUP_MODAL = "ADD_GROUP_MODAL";

class AddGroupModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    error: PropTypes.string,
    editing: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    projectList: PropTypes.objectOf(PropTypes.string).isRequired,
    addGroupRequest: PropTypes.func.isRequired,
  };

  render() {
    const {
      title,
      submitText,
      show,
      handleClose,
      groupFormData,
      groupTypeList,
      handleChange,
      error,
      editing,
      projectList,
      addGroupRequest,
    } = this.props;
    return (
      <Modal isOpen={show} onRequestClose={handleClose} title={title}>
        <ModalContent>
          <GroupForm
            formData={groupFormData}
            groupTypeOptions={groupTypeList}
            projectOptions={projectList}
            onChange={handleChange}
            error={error}
            editing={editing}
          />
        </ModalContent>
        <ModalFooter>
          <ControlGroup tight>
            <Button
              thin
              appearance="outline"
              onClick={handleClose}
              data-cy="GroupAdmin-cancelButton"
            >
              Cancel
            </Button>
            <Button
              data-cy="GroupAdmin-addGroup"
              thin
              additive
              onClick={addGroupRequest}
            >
              {submitText}
            </Button>
          </ControlGroup>
        </ModalFooter>
      </Modal>
    );
  }
}

const ConnectedAddGroupModal = connectModal({
  name: ADD_GROUP_MODAL,
  getModalState: (state) => state.betaModal,
})(AddGroupModal);

export default ConnectedAddGroupModal;
